<template>
  <div class="appMain">
    <transition name="pzz" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  computed: {
    key() {
      return this.$route.fullPath;
    }
  },
  async mounted() {}
};
</script>

<style lang="scss" scoped>
.appMain {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: $mainBGColor;
}
</style>
